<nav mat-tab-nav-bar [tabPanel]="tabPanel" [color]="'accent'">
  <a mat-tab-link [routerLink]="['/aftale']" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">Alle</a>
  <a mat-tab-link [routerLink]="['/seneste']" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
    <mat-icon svgIcon="clock" class="icon-16"></mat-icon>
    Mine seneste
  </a>
</nav>
<mat-tab-nav-panel #tabPanel>
  <router-outlet></router-outlet>
</mat-tab-nav-panel>
